import React, { useEffect, useMemo, useState } from 'react';
import { useTable, useSortBy } from 'react-table';
import { useNavigate } from 'react-router-dom';
import apiClient from '../utils/apiClient';
import { SERVER_BASE } from '../config/server';
import PendingReceiptVouchers from './pendingReceiptVoucher';

const SewadarHomePage = () => {
  const email = localStorage.getItem('email');
  const [profileDetails, setProfileDetails] = useState(null);
  const [pendingApprovals, setPendingApprovals] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchProfileDetails();
  }, []);

  useEffect(() => {
    if (profileDetails?.id) {
      fetchPendingApprovals(profileDetails.id);
    }
  }, [profileDetails]);

  const fetchProfileDetails = async () => {
    try {
      const response = await apiClient.get(`${SERVER_BASE}/getProfile`, {
        params: { email },
      });
      setProfileDetails(response.data?.[0] || null);
    } catch (err) {
      console.error('Error fetching profile details:', err);
    }
  };

  const fetchPendingApprovals = async (authorizedPersonId) => {
    setLoading(true);
    try {
      const response = await apiClient.get(`${SERVER_BASE}/getPendingApprovals`, {
        params: { authorizedPersonId },
      });
      setPendingApprovals(response.data || []);
    } catch (err) {
      console.error('Error fetching pending approvals:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleView = (row) => {
    switch (row.source) {
      case 'Delivery Challan':
        navigate('../../previewDeliveryChallan', { state: { id: row.id } });
        break;
      case 'Gate Pass':
        navigate('../../PreviewGatePass', { state: { id: row.id } });
        break;
      case 'Opening Stock':
        navigate('../../PreviewOpeningStock', { state: { id: row.id } });
        break;
        case 'Opening Stock Ledger':
          navigate('../../PreviewOpeningStockLedger', { state: { id: row.id } });
          break;
      case 'Inventory Draft':
        navigate('../../previewInventory', { state: { id: row.id } });
        break;
        case 'Inventory Ledger Draft':
          navigate('../../PreviewInventoryLedger', { state: { id: row.id } });
          break;
      case 'Inventory Location Transfer':
        navigate('../../previewTransferLocation', { state: { id: row.id } });
        break;
      case 'Inventory Status Transfer':
        navigate('../../previewTransferStatus', { state: { id: row.id } });
        break;
      case 'Issue Request':
        navigate('../../IssueRequestPreview', { state: { id: row.id } });
        break;
      case 'Unusable Production':
          navigate('../../UnusableProductionPreview', { state: { id: row.id } });
          break;
      case 'Transaction Entry':
            navigate('../../TransactionEntryPreview', { state: { id: row.id } });
            break;
      case 'Item Conversion':
            navigate('../../ItemConversionPreview', { state: { id: row.id } });
            break;
      case 'Project Requirement':
              navigate('../../ProjectRequirementPreview', { state: { id: row.id } });
              break;
      default:
        break;
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: '#',
        accessor: (_row, i) => i + 1,
        id: 'rowNumber',
        disableSortBy: true,
      },
      {
        Header: 'Document No',
        accessor: 'documentNo',
        Cell: ({ value }) => value || '-',
      },
      {
        Header: 'Date',
        accessor: 'date',
        Cell: ({ value }) => {
          const d = new Date(value);
          return isNaN(d.getTime()) ? '-' : d.toLocaleDateString();
        },
      },
      {
        Header: 'Status',
        accessor: 'status',
        Cell: ({ value }) => (
          <span className={`badge ${value === 'Pending' || value === 'Draft' ? 'bg-warning text-dark' : 'bg-success'}`}>
            {value}
          </span>
        ),
      },
      {
        Header: 'Type',
        accessor: 'source',
      },
      {
        Header: 'Action',
        accessor: 'action',
        disableSortBy: true,
        Cell: ({ row }) => (
          <button className="btn btn-sm btn-primary" onClick={() => handleView(row.original)}>
            Preview
          </button>
        ),
      },
    ],
    []
  );

  const tableInstance = useTable(
    {
      columns,
      data: pendingApprovals,
    },
    useSortBy
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = tableInstance;

  return (
    <div className="formcontainer mt-5">
      <h6>Pending Approvals</h6>

      {loading ? (
        <div className="text-center p-4">
          <div className="spinner-border text-primary" role="status"></div>
        </div>
      ) : (
        <div className="table-responsive mt-3">
          <table {...getTableProps()} className="table table-bordered table-striped">
            <thead className="table-light">
              {headerGroups.map(headerGroup => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map(column => (
                    <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                      {column.render('Header')}
                      <span className="ms-1">
                        {column.isSorted ? (column.isSortedDesc ? ' 🔽' : ' 🔼') : ''}
                      </span>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {rows.length === 0 ? (
                <tr>
                  <td colSpan={columns.length} className="text-center">No pending approvals</td>
                </tr>
              ) : (
                rows.map(row => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map(cell => (
                        <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                      ))}
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      )}
      <PendingReceiptVouchers/>
    </div>
  );
};

export default SewadarHomePage;
